"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOO_MANY_REQUESTS = exports.TEMPORARY_REDIRECT = exports.SWITCHING_PROTOCOLS = exports.SERVICE_UNAVAILABLE = exports.SEE_OTHER = exports.RESET_CONTENT = exports.REQUESTED_RANGE_NOT_SATISFIABLE = exports.REQUEST_URI_TOO_LONG = exports.REQUEST_TOO_LONG = exports.REQUEST_TIMEOUT = exports.REQUEST_HEADER_FIELDS_TOO_LARGE = exports.PROXY_AUTHENTICATION_REQUIRED = exports.PROCESSING = exports.PRECONDITION_REQUIRED = exports.PRECONDITION_FAILED = exports.PERMANENT_REDIRECT = exports.PAYMENT_REQUIRED = exports.PARTIAL_CONTENT = exports.OK = exports.NOT_MODIFIED = exports.NOT_IMPLEMENTED = exports.NOT_FOUND = exports.NOT_ACCEPTABLE = exports.NON_AUTHORITATIVE_INFORMATION = exports.NO_CONTENT = exports.NETWORK_AUTHENTICATION_REQUIRED = exports.MULTIPLE_CHOICES = exports.MULTI_STATUS = exports.MOVED_TEMPORARILY = exports.MOVED_PERMANENTLY = exports.METHOD_NOT_ALLOWED = exports.METHOD_FAILURE = exports.LOCKED = exports.LENGTH_REQUIRED = exports.INTERNAL_SERVER_ERROR = exports.INSUFFICIENT_STORAGE = exports.INSUFFICIENT_SPACE_ON_RESOURCE = exports.IM_A_TEAPOT = exports.HTTP_VERSION_NOT_SUPPORTED = exports.GONE = exports.GATEWAY_TIMEOUT = exports.FORBIDDEN = exports.FAILED_DEPENDENCY = exports.EXPECTATION_FAILED = exports.CREATED = exports.CONTINUE = exports.CONFLICT = exports.BAD_REQUEST = exports.BAD_GATEWAY = exports.ACCEPTED = void 0;
exports.getStatusText = exports.USE_PROXY = exports.UNSUPPORTED_MEDIA_TYPE = exports.UNPROCESSABLE_ENTITY = exports.UNAUTHORIZED = void 0;
exports.ACCEPTED = 202;
exports.BAD_GATEWAY = 502;
exports.BAD_REQUEST = 400;
exports.CONFLICT = 409;
exports.CONTINUE = 100;
exports.CREATED = 201;
exports.EXPECTATION_FAILED = 417;
exports.FAILED_DEPENDENCY = 424;
exports.FORBIDDEN = 403;
exports.GATEWAY_TIMEOUT = 504;
exports.GONE = 410;
exports.HTTP_VERSION_NOT_SUPPORTED = 505;
exports.IM_A_TEAPOT = 418;
exports.INSUFFICIENT_SPACE_ON_RESOURCE = 419;
exports.INSUFFICIENT_STORAGE = 507;
exports.INTERNAL_SERVER_ERROR = 500;
exports.LENGTH_REQUIRED = 411;
exports.LOCKED = 423;
exports.METHOD_FAILURE = 420;
exports.METHOD_NOT_ALLOWED = 405;
exports.MOVED_PERMANENTLY = 301;
exports.MOVED_TEMPORARILY = 302;
exports.MULTI_STATUS = 207;
exports.MULTIPLE_CHOICES = 300;
exports.NETWORK_AUTHENTICATION_REQUIRED = 511;
exports.NO_CONTENT = 204;
exports.NON_AUTHORITATIVE_INFORMATION = 203;
exports.NOT_ACCEPTABLE = 406;
exports.NOT_FOUND = 404;
exports.NOT_IMPLEMENTED = 501;
exports.NOT_MODIFIED = 304;
exports.OK = 200;
exports.PARTIAL_CONTENT = 206;
exports.PAYMENT_REQUIRED = 402;
exports.PERMANENT_REDIRECT = 308;
exports.PRECONDITION_FAILED = 412;
exports.PRECONDITION_REQUIRED = 428;
exports.PROCESSING = 102;
exports.PROXY_AUTHENTICATION_REQUIRED = 407;
exports.REQUEST_HEADER_FIELDS_TOO_LARGE = 431;
exports.REQUEST_TIMEOUT = 408;
exports.REQUEST_TOO_LONG = 413;
exports.REQUEST_URI_TOO_LONG = 414;
exports.REQUESTED_RANGE_NOT_SATISFIABLE = 416;
exports.RESET_CONTENT = 205;
exports.SEE_OTHER = 303;
exports.SERVICE_UNAVAILABLE = 503;
exports.SWITCHING_PROTOCOLS = 101;
exports.TEMPORARY_REDIRECT = 307;
exports.TOO_MANY_REQUESTS = 429;
exports.UNAUTHORIZED = 401;
exports.UNPROCESSABLE_ENTITY = 422;
exports.UNSUPPORTED_MEDIA_TYPE = 415;
exports.USE_PROXY = 305;
const statusCodeText = {
    [exports.ACCEPTED]: "Accepted",
    [exports.BAD_GATEWAY]: "Bad Gateway",
    [exports.BAD_REQUEST]: "Bad Request",
    [exports.CONFLICT]: "Conflict",
    [exports.CONTINUE]: "Continue",
    [exports.CREATED]: "Created",
    [exports.EXPECTATION_FAILED]: "Expectation Failed",
    [exports.FAILED_DEPENDENCY]: "Failed Dependency",
    [exports.FORBIDDEN]: "Forbidden",
    [exports.GATEWAY_TIMEOUT]: "Gateway Timeout",
    [exports.GONE]: "Gone",
    [exports.HTTP_VERSION_NOT_SUPPORTED]: "HTTP Version Not Supported",
    [exports.IM_A_TEAPOT]: "I'm a teapot",
    [exports.INSUFFICIENT_SPACE_ON_RESOURCE]: "Insufficient Space on Resource",
    [exports.INSUFFICIENT_STORAGE]: "Insufficient Storage",
    [exports.INTERNAL_SERVER_ERROR]: "Server Error",
    [exports.LENGTH_REQUIRED]: "Length Required",
    [exports.LOCKED]: "Locked",
    [exports.METHOD_FAILURE]: "Method Failure",
    [exports.METHOD_NOT_ALLOWED]: "Method Not Allowed",
    [exports.MOVED_PERMANENTLY]: "Moved Permanently",
    [exports.MOVED_TEMPORARILY]: "Moved Temporarily",
    [exports.MULTI_STATUS]: "Multi-Status",
    [exports.MULTIPLE_CHOICES]: "Multiple Choices",
    [exports.NETWORK_AUTHENTICATION_REQUIRED]: "Network Authentication Required",
    [exports.NO_CONTENT]: "No Content",
    [exports.NON_AUTHORITATIVE_INFORMATION]: "Non Authoritative Information",
    [exports.NOT_ACCEPTABLE]: "Not Acceptable",
    [exports.NOT_FOUND]: "Not Found",
    [exports.NOT_IMPLEMENTED]: "Not Implemented",
    [exports.NOT_MODIFIED]: "Not Modified",
    [exports.OK]: "OK",
    [exports.PARTIAL_CONTENT]: "Partial Content",
    [exports.PAYMENT_REQUIRED]: "Payment Required",
    [exports.PERMANENT_REDIRECT]: "Permanent Redirect",
    [exports.PRECONDITION_FAILED]: "Precondition Failed",
    [exports.PRECONDITION_REQUIRED]: "Precondition Required",
    [exports.PROCESSING]: "Processing",
    [exports.PROXY_AUTHENTICATION_REQUIRED]: "Proxy Authentication Required",
    [exports.REQUEST_HEADER_FIELDS_TOO_LARGE]: "Request Header Fields Too Large",
    [exports.REQUEST_TIMEOUT]: "Request Timeout",
    [exports.REQUEST_TOO_LONG]: "Request Entity Too Large",
    [exports.REQUEST_URI_TOO_LONG]: "Request-URI Too Long",
    [exports.REQUESTED_RANGE_NOT_SATISFIABLE]: "Requested Range Not Satisfiable",
    [exports.RESET_CONTENT]: "Reset Content",
    [exports.SEE_OTHER]: "See Other",
    [exports.SERVICE_UNAVAILABLE]: "Service Unavailable",
    [exports.SWITCHING_PROTOCOLS]: "Switching Protocols",
    [exports.TEMPORARY_REDIRECT]: "Temporary Redirect",
    [exports.TOO_MANY_REQUESTS]: "Too Many Requests",
    [exports.UNAUTHORIZED]: "Unauthorized",
    [exports.UNPROCESSABLE_ENTITY]: "Unprocessable Entity",
    [exports.UNSUPPORTED_MEDIA_TYPE]: "Unsupported Media Type",
    [exports.USE_PROXY]: "Use Proxy"
};
function getStatusText(statusCode) {
    return statusCodeText[statusCode] || "Unknown Status";
}
exports.getStatusText = getStatusText;
//# sourceMappingURL=httpStatusCodes.js.map